import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const Hionline = ({ navigation, route }: any) => {
  const {
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
    filingdescription,
    totalwithholdingallowance,
    amount,
    resultofmartialdeductionsandcurrentyeardeduction,
    additionofresultandcurrentyearadjustment,
    Resultofnonwageincomes,
    divideresultofnonwage1144
  } = route.params

  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()

  const { loading, posthionline } = useFormsStore()

  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      completeOnline: true,
      essUserKey: intializeStore.initializeData?.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      martialstatus: Number(values.filingStatus),
      totalnoofallowances: totalwithholdingallowance,
      additionalamount: Number(values.additonalamount),
      youasadependent: Number(values.youasadependent) === 2 ? null : Number(values.youasadependent),
      martialwithjobstatus: Number(values.martialwithjobstatus) === 2 ? null : Number(values.martialwithjobstatus),
      spouseclaimingstatus: Number(values.spouseclaimingstatus) === 2 ? null : Number(values.spouseclaimingstatus),
      ageadditionalwithholdingallowances: values.ageadditionalwithholdingallowances ? Number(values.ageadditionalwithholdingallowances) : null,
      noofdependents: Number(values.noofdependents),
      claimashousehold: Number(values.claimashousehold) === 2 ? null : Number(values.claimashousehold),
      totaltaxcredits: Number(values.totaltaxcredits) === 2 ? null : Number(values.totaltaxcredits),
      itemizeorclaimadjustmentstoincome: divideresultofnonwage1144,
      totalwithholdingallowances: totalwithholdingallowance,
      currentyearitemizeddeductions: Number(values.currentyearitemizeddeductions),
      martialdeductions: Number(values?.filingamount),
      resultofmartialdeductionsandcurrentyeardeductions: resultofmartialdeductionsandcurrentyeardeduction,
      estimateadjustmentstoincome: Number(values.estimateadjustmentstoincome),
      additionofresultandcurrentyearadjustments: additionofresultandcurrentyearadjustment,
      estimatenonwageincome: Number(values.estimatenonwageincome),
      resultofnonwageincome: Resultofnonwageincomes,
      divideresultofnonwageby1144: divideresultofnonwage1144,
      sign: signatureDataURL
    }
    const response = await posthionline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'HI Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('HiinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
          })
        }
        onSubmit={handlesubmit}
        stateValue='HI'
      />
    </>
  )
}
export default Hionline
